var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MStoreUnsupportedInput',{attrs:{"fieldLabel":_vm.inputProperties.fieldLabel,"htmlElementId":_vm.inputProperties.htmlElementId,"message":_vm.unsupportedMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }